import * as PropTypes from 'prop-types';

import * as ArchiveConstants from 'archive/ArchiveConstants';
import {Permissions} from 'auth/PermissionConstants';
import {User} from 'constants/UserConstants';
import * as FileConstants from 'folder-items/FileConstants';
import {getMaxRowsConfig} from 'notebook/structured-tables/util/checkTableCapacity';
import {Optional} from 'util/Types';

export const INVALID = 'INVALID';
export const VALID = 'VALID';
export const VALIDATION_STATUSES = [INVALID, VALID];

export {AssayRecordOriginType} from 'graphql-client/__generated/graphqlGlobalTypes';

// Models a 4xx response from the server when fetching records so that components can render that repsonse.
export const DATA_MISSING = 'DATA_MISSING';

export const OVERSIZED_RESULTS_TABLE_TOOLTIP =
  'Table has too many rows to be expanded. Download to view the data.';

export function isOversized(count: number): boolean {
  return count >= getMaxRowsConfig(false);
}

interface ConditionAndReplicate {
  conditionName: string;
  replicateNumber: number;
}

interface BaseAssayRecord {
  id: string;
  archiveRecord: Optional<ArchiveConstants.ArchiveRecord>;
  createdAt: string;
  creator: User;
  originType: string;
  schemaId: string;
  tags: Array<FileConstants.Tag>;
  allTags: Array<FileConstants.Tag>;
  apiId?: string;
  conditionAndReplicate?: ConditionAndReplicate;
}

export type AssayResult = BaseAssayRecord & {modifiedAt: string};
export interface AssayRun extends BaseAssayRecord {
  connection: {id: string} | null;
  schemaName: string;
  equipment: {id: string} | null;
  permissions: Permissions;
  shouldRecordEquipment: boolean;
  studyIds: Array<string>;
  analysisIds: Array<string>;
}

export const ASSAY_RECORD_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  archiveRecord: ArchiveConstants.ARCHIVE_RECORD_SHAPE,
  conditionAndReplicate: PropTypes.object,
  createdAt: PropTypes.string.isRequired,
  creator: PropTypes.object.isRequired,
  originType: PropTypes.string.isRequired,
  schemaId: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(FileConstants.TAG_SHAPE).isRequired,
  allTags: PropTypes.arrayOf(FileConstants.TAG_SHAPE).isRequired,
  apiId: PropTypes.string,
});

export const ASSAY_RESULT_SHAPE = ASSAY_RECORD_SHAPE;

export const RUN_OUTPUT_TABLE_ICON = 'sample';
export const RUN_OUTPUT_TABLE_LABEL = 'Run outputs';
